// src/components/filters/FilterCategories.jsx
import React, { useEffect, useMemo, useState } from "react";
import RenderCategories from "./RenderCategories";
import { useFilterContext } from "../../helpers/FilterContext";
import { useCategories } from "../../helpers/CategoriesContext";

function FilterCategories({ filter, filtersContent, fetchedFilters }) {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const { state, dispatch } = useFilterContext();

  const [categoriesSelected, setCategoriesSelected] = useState([]);

  const { data: categoriesResponse, loading } = useCategories();

  const categoriesList = useMemo(() => {
    const raw = categoriesResponse?.data ?? categoriesResponse;
    if (!raw) return [];
    if (Array.isArray(raw)) return raw;
    if (Array.isArray(raw?.data)) return raw.data;
    if (raw?.data && typeof raw.data === "object") return Object.values(raw.data);
    if (typeof raw === "object") return Object.values(raw);
    return [];
  }, [categoriesResponse]);
  useEffect(() => {
    if (fetchedFilters && fetchedFilters.categories_ids) {
      const selected = Object.keys(fetchedFilters.categories_ids).map(
        (key) => fetchedFilters.categories_ids[key]
      );
      setCategoriesSelected(selected);
    } else {
      setCategoriesSelected([]);
    }
  }, [fetchedFilters]);

  function deleteCategorieId() {
    setCategoriesSelected([]);
    dispatch({ type: "REMOVE_FILTER", payload: "categories_ids" });
  }

  function handleCheckBoxClick(categoryId) {
    const isAlreadySelected = categoriesSelected.some(
      (cat) => String(cat.value) === String(categoryId)
    );

    let updatedCategories;
    if (isAlreadySelected) {
      updatedCategories = categoriesSelected.filter(
        (cat) => String(cat.value) !== String(categoryId)
      );
    } else {
      const found = categoriesList.find((cat) => String(cat.id) === String(categoryId));
      if (found) {
        updatedCategories = [
          ...categoriesSelected,
          {
            value: categoryId,
            text: found.description || found.name || found.slug || String(categoryId),
          },
        ];
      } else {
        console.warn(`⚠️ Categoría con ID ${categoryId} no encontrada en el árbol del contexto.`);
        return;
      }
    }

    setCategoriesSelected(updatedCategories);

    const selectedIds = updatedCategories.map((cat) => cat.value);
    dispatch({
      type: "UPDATE_FILTERS",
      payload: { filterId: "categories_ids", values: selectedIds },
    });
  }

  return (
    <div className="flex flex-col items-center py-4">
      <RenderCategories
        categories={categoriesList}
        fetchedFilters={fetchedFilters}
        onCategoryClick={handleCheckBoxClick}
        onClearAll={deleteCategorieId}
      />
    </div>
  );
}

export default FilterCategories;
